import { render, staticRenderFns } from "./DefaultButton.vue?vue&type=template&id=d2ef7fe4&scoped=true&"
import script from "./DefaultButton.vue?vue&type=script&lang=ts&"
export * from "./DefaultButton.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultButton.vue?vue&type=style&index=0&id=d2ef7fe4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ef7fe4",
  null
  
)

export default component.exports